import { normalizeCategoryLink } from "../../../utils/index.js";
import { GRS_PRODUCT_TYPE_PHARMACY, GRS_PRODUCT_TYPE_TRAVEL } from "./constants.js";
const getLucidWorksGRSLocale = (locale) => {
  const parts = locale.split("-");
  const lucidWorksLocale = `${parts[0].toLowerCase()}-${parts[1].toUpperCase()}`;
  return lucidWorksLocale;
};
const getWarehousesList = (warehouse) => {
  var _a;
  const distributionCenters = warehouse.distributionCenters;
  const groceryCenters = warehouse.groceryCenters;
  const nearestWarehouse = (_a = warehouse == null ? void 0 : warehouse.nearestWarehouse) == null ? void 0 : _a.catalog;
  const combinedWarehouseList = [
    distributionCenters,
    groceryCenters,
    nearestWarehouse
  ].filter((item) => Array.isArray(item) ? item.length > 0 : item).map((item) => Array.isArray(item) ? item.join(",") : item).join(",");
  return combinedWarehouseList;
};
const normalizeWarehouseText = (whText) => {
  const firstLetterRx = /(^|\s)[a-z]/g;
  function upperCase(str) {
    return str.toUpperCase();
  }
  whText = whText.toLowerCase();
  return whText.replace(firstLetterRx, upperCase);
};
const getSuggestionDataBiPrivate = (suggestion) => {
  if (suggestion.leads_to_fsa_chdi || suggestion.item_chdi_eligible || suggestion.item_fsa_eligible) {
    return true;
  } else {
    return false;
  }
};
const getRecommendedSuggestionDataBiPrivate = (suggestion) => {
  return !!suggestion.leads_to_fsa_chdi;
};
const getSuggestionFullImage = (suggestion, pharmacyPlaceholderImage) => {
  if (pharmacyPlaceholderImage && (suggestion.FullImage === "placeholder" || !suggestion.FullImage) && suggestion.type === "Product" && // LW API returns pharmacy_drug_id for pharmacy products
  (suggestion.pharmacy_drug_id || // GRS API pharamacy products have productType as 'Pharmacy'
  suggestion.productType === GRS_PRODUCT_TYPE_PHARMACY)) {
    return pharmacyPlaceholderImage;
  }
  return suggestion.FullImage;
};
const createProductSection = (suggestion, pharmacyPlaceholderImage) => {
  const productData = {
    ...suggestion,
    FullImage: getSuggestionFullImage(suggestion, pharmacyPlaceholderImage),
    dataBiPrivate: getSuggestionDataBiPrivate(suggestion),
    group: "productSection"
  };
  return productData;
};
const addUniqueAutomationId = (suggestions) => {
  const typeCounts = {};
  return suggestions.map((suggestion) => {
    if (!suggestion.type) {
      return {
        ...suggestion
      };
    }
    const count = typeCounts[suggestion.type] || 0;
    typeCounts[suggestion.type] = count + 1;
    return {
      ...suggestion,
      automationId: `suggestion-${suggestion.type}${count !== 0 ? count : ""}`
    };
  });
};
const getLimitedSuggestions = ({
  searchTermSection,
  productSection,
  warehouseSection,
  maxTotalSuggestions,
  maxSearchTermSuggestions
}) => {
  const searchTermSuggestions = searchTermSection.slice(
    0,
    maxSearchTermSuggestions
  );
  const allSuggestions = searchTermSuggestions.concat(
    productSection,
    warehouseSection
  );
  const allSuggestionsWithAutomationId = addUniqueAutomationId(allSuggestions);
  const maximumSuggestions = allSuggestionsWithAutomationId.slice(
    0,
    maxTotalSuggestions
  );
  const maximumSuggestionsWithIndex = maximumSuggestions.map(
    (suggestion, index) => {
      return {
        ...suggestion,
        index
      };
    }
  );
  return maximumSuggestionsWithIndex;
};
const getOptionsFromSuggestions = ({
  pharmacyPlaceholderImage,
  maxSearchTermSuggestions,
  maxTotalSuggestions,
  suggestions
}) => {
  const searchTermSection = [];
  const productSection = [];
  const warehouseSection = [];
  suggestions == null ? void 0 : suggestions.forEach((suggestion) => {
    if (suggestion.label !== void 0 || suggestion.type.toLowerCase() === "recommendedsearch") {
      switch (suggestion.type.toLowerCase()) {
        case "recommendedsearch":
          if ("name" in suggestion) {
            searchTermSection.push(
              mapRecommendedSearchToSuggestion(suggestion)
            );
          }
          break;
        case "popularsearch":
        case "shadowdimension":
        case "category":
        case "brand":
          searchTermSection.push({
            ...suggestion,
            dataBiPrivate: getSuggestionDataBiPrivate(suggestion),
            group: "searchTermSection"
          });
          break;
        case "product":
          productSection.push(
            createProductSection(
              suggestion,
              pharmacyPlaceholderImage
            )
          );
          break;
        case "warehouse":
          suggestion.index = warehouseSection.length;
          suggestion.WarehouseAddress = normalizeWarehouseText(
            suggestion.WarehouseAddress ?? ""
          );
          warehouseSection.push({
            ...suggestion,
            dataBiPrivate: getSuggestionDataBiPrivate(suggestion),
            group: "warehouseSection",
            label: `${suggestion.label} ${suggestion.type} ${suggestion.WarehouseAddress}`
          });
          break;
      }
    }
  });
  const limitedSuggestions = getLimitedSuggestions({
    maxSearchTermSuggestions,
    maxTotalSuggestions,
    productSection,
    searchTermSection,
    warehouseSection
  });
  return limitedSuggestions;
};
const getSuggestionPlaceholderText = (options, value) => {
  var _a, _b;
  const sliceMatchingText = (searchTerm, text) => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const lowerText = text.toLowerCase();
    const index = lowerSearchTerm.indexOf(lowerText);
    if (index !== -1) {
      return searchTerm.slice(index + text.length);
    } else {
      return void 0;
    }
  };
  const firstMatchingSearchTerm = (((_a = options[0]) == null ? void 0 : _a.group) === "searchTermSection" || ((_b = options[0]) == null ? void 0 : _b.group) === "productSection") && options[0].label;
  const suggestionPlaceholderText = firstMatchingSearchTerm ? sliceMatchingText(firstMatchingSearchTerm, value) : void 0;
  return {
    suggestionFullText: firstMatchingSearchTerm,
    suggestionPlaceholderText
  };
};
const getAddDivider = (group, options) => {
  if (group === "searchTermSection") {
    return false;
  } else if (group === "productSection") {
    return options.some((option) => option.group === "searchTermSection");
  } else if (group === "warehouseSection") {
    return options.some(
      (option) => option.group === "searchTermSection" || option.group === "productSection"
    );
  } else {
    return false;
  }
};
const getOptionFromLabel = (options, label) => {
  return options.find(
    (option) => option.label === label
  );
};
const getSEOFriendlyUrl = (term) => {
  return term.replace(/\s+/g, "-").replace(/[^A-Za-z0-9-]/g, "").toLowerCase();
};
const getPathFromOption = ({
  categoryUrlPath,
  option,
  publishedCategories,
  refineParameterSuffix = "",
  searchUrl,
  value
}) => {
  const fallbackPath = `${searchUrl}${encodeURIComponent(value)}`;
  if (option.type) {
    switch (option.type.toLowerCase()) {
      case "recommendedsearch":
        return fallbackPath;
      case "popularsearch":
        return fallbackPath;
      case "category":
        if (option.baseUrl) {
          return normalizeCategoryLink(
            categoryUrlPath,
            option.baseUrl,
            publishedCategories
          );
        } else {
          return fallbackPath;
        }
      case "warehouse":
        if (option.baseUrl) {
          return option.baseUrl;
        } else {
          return fallbackPath;
        }
      case "shadowdimension":
        if (option.baseUrl && option.Brand_attr) {
          return `${option.baseUrl}?refine=||Brand_attr-${encodeURIComponent(option.Brand_attr)}${refineParameterSuffix}`;
        } else {
          return fallbackPath;
        }
      case "brand":
        if (option.Brand_attr) {
          return `${searchUrl}${encodeURIComponent(value)}&refine=||Brand_attr-${encodeURIComponent(option.Brand_attr)}${refineParameterSuffix}`;
        } else {
          return fallbackPath;
        }
      case "product": {
        if (option.travel_pageURL) {
          return option.travel_pageURL;
        } else if (option.productType === GRS_PRODUCT_TYPE_TRAVEL && option.baseUrl) {
          return option.baseUrl;
        } else if (option.pharmacy_drug_id && option.term) {
          return `/cmpps?drugIdentifierParam=${option.pharmacy_drug_id}&drugNameParam=${encodeURIComponent(option.term)}`;
        } else if (option.productType === GRS_PRODUCT_TYPE_PHARMACY && option.baseUrl) {
          return option.baseUrl;
        } else if (option.group_id && option.term) {
          const productTerm = option.term;
          const seoFriendlyTerm = productTerm ? getSEOFriendlyUrl(productTerm) : "";
          return `/${seoFriendlyTerm}.product.${option.group_id}.html`;
        } else {
          return fallbackPath;
        }
      }
      default:
        return fallbackPath;
    }
  } else {
    return fallbackPath;
  }
};
function mapRecommendedSearchToSuggestion(recommendedSearch) {
  const { name, type } = recommendedSearch;
  return {
    label: name,
    type,
    dataBiPrivate: getRecommendedSuggestionDataBiPrivate(recommendedSearch),
    group: "searchTermSection"
  };
}
export {
  getAddDivider,
  getLucidWorksGRSLocale,
  getOptionFromLabel,
  getOptionsFromSuggestions,
  getPathFromOption,
  getSEOFriendlyUrl,
  getSuggestionFullImage,
  getSuggestionPlaceholderText,
  getWarehousesList,
  mapRecommendedSearchToSuggestion,
  normalizeWarehouseText
};
